import { useEffect } from "react";
import { queryKeys } from "@/constants";
import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash";
import { Project, Workbook, WorkbookTransform } from "@/models/workbook";
import { NotifyService } from "@/helpers/notify";
import { favouriteApi } from "@/services/favourite";

interface UseGetListFavouriteProps {
  enabledToastError?: boolean;
}

export const useGetListFavourite = (
  { enabledToastError = false }: UseGetListFavouriteProps = { enabledToastError: false }
) => {
  const query = useQuery({
    queryKey: [queryKeys.favourite],
    queryFn: async () => {
      const response = await favouriteApi.getList();
      const workbooks: Workbook[] = isEmpty(response.data.workbooks)
        ? []
        : Object.values(response.data.workbooks).filter(
            (workbook) => workbook?.discoverable === true
          );
      const projects: Project[] = isEmpty(response.data.projects)
        ? []
        : Object.values(response.data.projects);

      return { workbooks, projects } as WorkbookTransform;
    },
  });

  useEffect(() => {
    if (query.error) {
      // eslint-disable-next-line no-console
      console.error("useGetListFavourite", query.error.message);
      enabledToastError && NotifyService.error(query.error.message);
    }
  }, [query.error, enabledToastError]);

  return query;
};
